import Component from "../classes/Component";
import $ from 'jquery';

export default class Readmore extends Component {
  constructor() {
    super({});
    this.element = [...document.querySelectorAll("[data-components-readmore]")];
    this.init();
  }
  init() {
    if (this.element) {
      this.showReadmore();
    }
  }

  showReadmore() {
    $('.engagements-rse').each(function (){
      var cardItem = $(this).find(".card-download");
      var button = $(this).find('.link--readmore');

      cardItem.each(function( index ) {
        if(index > 3) {
          cardItem.eq(index).hide();
        }
      });
      button.click(function (e){
        e.preventDefault();
        cardItem.show();
        $(this).parent().hide();
      });
    });
  }
}
